
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import AppSaleTypeMultiSelect from "@/components/sales/SaleTypeMultiSelect.vue";
import AppFilterItem from "@/components/price-rules/PriceRuleEditFilterItem.vue";
import AppProductSkuAutocomplete from "@/components/products/ProductSkuAutocompleteWithoutModal.vue";
import AppProductEditGroups from "@/components/products/ProductEditGroupsLight.vue";
import { LoyaltyConfig } from "@/models/dossier-configs/loyalty";
import { DossierConfigService } from "@/services/dossier-config-service";
import { Condition, Operator } from "@/utils/condition/condition";
import { Product } from "@/models/base";
import { ProductGroupModel } from "@/models/base/product-group-model";
import { ProductGroup } from "@/models/base/product-group";
import { ProductGroupService } from "@/services";

export default Vue.extend({
	data(){
		return {
			config: new LoyaltyConfig(),
			openedCondition: null as null | Condition,
			product: new Product(),
			sending: false
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings/sales", value: this.$ct("sale/purchase")
				},
				{
					value: this.$ct("loyalty-card")
				}
			] as IBreadCrumb[];
		}
	},
	methods: {
		async save(){
			if (this.sending) return;
			try {
				this.sending = true;
				this.config = await DossierConfigService.setLoyaltyConfig(this.config);
				this.$router.back();
			} catch (err) {
			}
			this.sending = false;
		},
		addNewFilter(){
			let condition = new Condition();
			condition.Prop = "ProductSku";
			condition.Operator = Operator.EQ;
			condition.Value = "1";
			this.config.ExclusionFilters.push(condition);
			this.openedCondition = condition;
		},
		deleteItem(i:number){
			this.config.ExclusionFilters.splice(i, 1);
		},
		editItem(item:Condition){
			if (this.openedCondition == item) {
				this.openedCondition = null;
				return;
			}
			this.openedCondition = item;
		},
		onSingleProduct(item:Product){
			let c = new Condition({"Prop": "ProductSku", "Operator": Operator.EQ, "Value": item.Sku, "Info": "Art. = '" + item.Name + "' (" + item.Sku + ")"});
			this.config.ExclusionFilters.push(c);
		},
		onProductSelect(items:Product[]){
			let isOr = items.length > 1;
			items.forEach((item:Product)=>{
				let c = new Condition({"IsOr": isOr, "Prop": "ProductSku", "Operator": Operator.EQ, "Value": item.Sku, "Info": "Art. = '" + item.Name + "' (" + item.Sku + ")"});
				this.config.ExclusionFilters.push(c);
			});
		},
		setMainGroup(id:number){
			this.product.MainGroup = new ProductGroupModel({ID: id});
			this.product.GroupID = id;
		},
		async getGroupInfo(id:number):Promise<ProductGroup>{
			return ProductGroupService.getGroupByID(id);
		},
		async onGroupSubmit(){
			if (this.product.MainGroup){
				let g = await this.getGroupInfo(this.product.MainGroup.ID);
				let c = new Condition();
				c.IsOr = true;
				c.Prop = "Product.MainGroup.ParentGroupID";
				c.Operator = Operator.EQ;
				c.Value = this.product.MainGroup.ID.toString();
				c.Info = `Bovenliggende groep='${g.Name}'`;
				this.config.ExclusionFilters.push(c);
				c = new Condition();
				c.IsOr = true;
				c.Prop = "Product.MainGroup.ID";
				c.Operator = Operator.EQ;
				c.Value = this.product.MainGroup.ID.toString();
				c.Info = `Groep='${g.Name}'`;
				this.config.ExclusionFilters.push(c);
				return;
			}
			if (this.product.GroupID){
				let g = await this.getGroupInfo(this.product.GroupID);
				let c = new Condition({"Prop": "Product.GroupID", "Operator": Operator.EQ, "Value": this.product.GroupID.toString(), "Info": "Subgroep='" + g.Name + "'"});
				this.config.ExclusionFilters.push(c);
			}
		}
	},
	mounted(){
		this.config = DossierConfigService.getLoyaltyConfig();
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppSaleTypeMultiSelect,
		AppFilterItem,
		AppProductSkuAutocomplete,
		AppProductEditGroups
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
